import { computed, reactive } from "vue";
import DealerKit from "../../js/api";
const state = reactive({
    isLoading: false,
    teams: undefined
});
export default function useAuthorisedTeams() {
    async function loadTeams() {
        if (!state.isLoading && state.teams === undefined) {
            state.isLoading = true;
            await DealerKit.teams.getTeams(true).then((response) => {
                state.teams = response.data.data;
            }).finally(() => {
                state.isLoading = false;
            });
        }
        return state.teams;
    }
    const authorisedTeams = computed(() => {
        return state.teams ?? [];
    });
    const authorisedBookableTeams = computed(() => {
        return state.teams ? state.teams.filter(team => team.accepts_bookings) : [];
    });
    const isLoading = computed(() => {
        return state.isLoading;
    });
    loadTeams();
    return {
        isLoading,
        authorizedTeams: authorisedTeams,
        authorizedBookableTeams: authorisedBookableTeams,
    };
}
